import styled, { css, keyframes } from 'styled-components';

const slideDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  60% {
    opacity: 1;
    transform: translateY(6px);
  }
  80% {
    transform: translateY(-2px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  position: relative;
  height: 5rem;
  flex: 1;
  min-width: 0;
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0.375rem;
  overflow: hidden;
  animation: ${slideDown} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
`;

type BannerSlideProps = {
  $active: boolean;
};

export const BannerSlide = styled.div<BannerSlideProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition: opacity 0.6s ease-in-out;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.375rem;
  }
`;

export const BannerLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.375rem;
  }
`;

export const Dots = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  z-index: 2;
`;

type DotProps = {
  $active: boolean;
};

export const Dot = styled.button<DotProps>`
  ${({ $active }) => css`
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 50%;
    border: none;
    padding: 0;
    cursor: pointer;
    background: ${$active ? 'white' : 'rgba(255, 255, 255, 0.5)'};
    transition: background 0.2s;
  `}
`;
